import {
  getPageHeader,
  OrganisationList,
  OrganisationDetailsCanvas,
  PageContainer,
  PageHeader,
  PageHeaderLeading,
  PageHeaderActionPrimary,
  PageHeaderActions,
  useArtifactCanvas,
} from '@yeshuman/sdk'
import { useCallback, useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { Building2, Plus } from 'lucide-react'

export function EmployerOrganisationsPage() {
  const queryClient = useQueryClient()
  const { openCanvas, closeCanvas } = useArtifactCanvas()
  const { title, description } = getPageHeader(
    '/employer/organisations',
    'Organisations',
    'Manage your organisations and the jobs linked to each one.'
  )

  useEffect(() => {
    return () => {
      closeCanvas()
    }
  }, [closeCanvas])

  const handleOpenCreateCanvas = useCallback(() => {
    openCanvas({
      title: 'Create organisation',
      preventAutoFocus: true,
      content: (
        <OrganisationDetailsCanvas
          onClose={closeCanvas}
          onCreated={() => {
            void queryClient.invalidateQueries({ queryKey: ['managed-organisations'] })
          }}
        />
      ),
    })
  }, [closeCanvas, openCanvas, queryClient])

  return (
    <PageContainer>
      <PageHeader
        leading={<PageHeaderLeading />}
        title={title}
        description={description}
        icon={<Building2 className="h-5 w-5" />}
        actions={
          <PageHeaderActions
            primary={
              <PageHeaderActionPrimary type="button" onClick={handleOpenCreateCanvas}>
                <Plus className="h-4 w-4" aria-hidden />
                Add Organisation
              </PageHeaderActionPrimary>
            }
          />
        }
      />

      <OrganisationList onOpenCreate={handleOpenCreateCanvas} />
    </PageContainer>
  )
}
